import user from "./user";
import app from "./app";
import game from "./game";
export default {
  user,
  app,
  game
};
